export default function reducer(state = {
  outlets: [],
  unlinkedOutlets: [],
  fetching: false,
  fetched: false,
  errors: {},
}, action) {
  switch (action.type) {
    case 'OUTLETS_CN_INIT': {
      return {
        outlets: [], fetching: false, fetched: false, errors: {}
      };
    }
    case 'GET_OUTLETS_CN_PENDING':
    case 'GET_PENDING_OUTLETS_CN_PENDING': {
      return {...state, fetching: true, fetched: false};
    }
    case 'GET_OUTLETS_CN_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        outlets: action.payLoad.data,
      };
    }
    case 'GET_PENDING_OUTLETS_CN_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        unlinkedOutlets: action.payLoad.data
      };
    }
    case 'GET_OUTLETS_CN_REJECTED':
    case 'GET_PENDING_OUTLETS_CN_REJECTED':
      return {
        ...state, errors: action.payLoad
      };
    default:
  }

  return {...state};
}
